import React from 'react'
import PropTypes from 'prop-types'
import { updateObject } from 'helpers/objectHelpers'
import FormImage from 'components/forms/image/FormImage'
import FormSwitch from 'components/forms/bases/FormSwitch'

const FormImageElement = ({
  isHorizontal,
  className,
  style,
  value,
  value: {
    source = '',
    link = '',
    target = '',
  },
  onChange,
  children,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <FormImage style={style} className={className}>
      <FormImage.Column width={isHorizontal ? 5 : 12}>
        <FormImage.Image
          src={source}
          alt="image"
          style={isHorizontal ? { width: '100%' } : {}}
        />
      </FormImage.Column>
      <FormImage.Column width={isHorizontal ? 7 : 12}>
        <FormImage.Source
          value={source}
          onChange={(val) => handleChange(val, 'source')}
        />
      </FormImage.Column>
      <FormImage.Column width={12}>
        <FormImage.Link
          value={link}
          style={{ marginTop: -14 }}
          onChange={(val) => handleChange(val, 'link')}
        />
        <FormImage.Target
          value={target}
          style={isHorizontal ? { width: '100%' } : {}}
          onChange={(val) => handleChange(val, 'target')}
        />
        {children}
      </FormImage.Column>
    </FormImage>
  )
}

FormImageElement.propTypes = {
  isHorizontal: PropTypes.bool,
}
FormImageElement.defaultProps = {
  isHorizontal: false
}
FormImageElement.ActiveSwitch = ({ value, onChange }) => (
  <FormSwitch
    label="active"
    value={value}
    onChange={onChange}
  />
)

export default FormImageElement



// WEBPACK FOOTER //
// ./src/components/forms/image/FormImageElement.js